import { render, staticRenderFns } from "./statistics-chart.vue?vue&type=template&id=6c901034&scoped=true&"
import script from "./statistics-chart.vue?vue&type=script&lang=js&"
export * from "./statistics-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c901034",
  null
  
)

export default component.exports